"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _json = require("../json");

function create(props) {
  var getUrlForId = props.getUrlForId,
      getUrlForMultiIds = props.getUrlForMultiIds,
      getEmptyResource = props.getEmptyResource,
      mapData = props.mapData,
      cache = props.cache,
      fetchEnv = props.fetchEnv;

  function _fetchOne(_x) {
    return _fetchOne2.apply(this, arguments);
  }

  function _fetchOne2() {
    _fetchOne2 = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee(id) {
      var url, result, data, mapped;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // try to fetch
              url = getUrlForId(id);
              _context.next = 3;
              return (0, _json.getJSON)(url, fetchEnv);

            case 3:
              result = _context.sent;

              if (!(result.status === 'ok')) {
                _context.next = 8;
                break;
              }

              data = result.data;
              mapped = mapData(data);
              return _context.abrupt("return", mapped);

            case 8:
              return _context.abrupt("return", null);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetchOne2.apply(this, arguments);
  }

  function getResource(_x2) {
    return _getResource.apply(this, arguments);
  }

  function _getResource() {
    _getResource = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee2(id) {
      var key, cachedValue, item;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              key = getUrlForId(id); // try to return from cache

              cachedValue = cache.getValue(key, null);

              if (!(cachedValue !== null)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", Promise.resolve(cachedValue));

            case 4:
              _context2.next = 6;
              return _fetchOne(id);

            case 6:
              item = _context2.sent;

              if (!(item !== null)) {
                _context2.next = 10;
                break;
              }

              cache.setValue(key, item);
              return _context2.abrupt("return", item);

            case 10:
              return _context2.abrupt("return", getEmptyResource());

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _getResource.apply(this, arguments);
  }

  function selectResource(id) {
    var key = getUrlForId(id); // try to return from cache

    var cachedValue = cache.getValue(key, null);

    if (cachedValue !== null) {
      return cachedValue;
    }

    return getEmptyResource();
  }

  function _fetchMulti(_x3) {
    return _fetchMulti2.apply(this, arguments);
  }

  function _fetchMulti2() {
    _fetchMulti2 = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee3(ids) {
      var url, _result, mappedList, result;

      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(ids.length === 0)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", []);

            case 2:
              if (!getUrlForMultiIds) {
                _context3.next = 10;
                break;
              }

              url = getUrlForMultiIds(ids);
              _context3.next = 6;
              return (0, _json.getJSON)(url, fetchEnv);

            case 6:
              _result = _context3.sent;

              if (!(_result.status === 'ok')) {
                _context3.next = 10;
                break;
              }

              mappedList = (_result.data || []).map(mapData);
              return _context3.abrupt("return", mappedList);

            case 10:
              _context3.next = 12;
              return Promise.all(ids.map(_fetchOne));

            case 12:
              result = _context3.sent;
              return _context3.abrupt("return", result.filter(Boolean));

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _fetchMulti2.apply(this, arguments);
  }

  function getResourcesMap(_x4) {
    return _getResourcesMap.apply(this, arguments);
  }

  function _getResourcesMap() {
    _getResourcesMap = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee4(ids) {
      var cachedList, finalMap, fetchIds, mappedList, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, mapped, _id3, key;

      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              cachedList = function () {
                var result = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _id2 = _step.value;
                    var key = getUrlForId(_id2);
                    var cachedValue = cache.getValue(key, null);

                    if (cachedValue !== null) {
                      result.push([_id2, cachedValue]);
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                      _iterator["return"]();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                return result;
              }();

              finalMap = new Map(cachedList);
              fetchIds = ids.filter(function (_id) {
                return !finalMap.has(_id);
              });
              _context4.next = 5;
              return _fetchMulti(fetchIds);

            case 5:
              mappedList = _context4.sent;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context4.prev = 9;

              for (_iterator2 = mappedList[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                mapped = _step2.value;
                _id3 = mapped.id;
                finalMap.set(_id3, mapped);
                key = getUrlForId(_id3);
                cache.setValue(key, mapped);
              }

              _context4.next = 17;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](9);
              _didIteratorError2 = true;
              _iteratorError2 = _context4.t0;

            case 17:
              _context4.prev = 17;
              _context4.prev = 18;

              if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
              }

            case 20:
              _context4.prev = 20;

              if (!_didIteratorError2) {
                _context4.next = 23;
                break;
              }

              throw _iteratorError2;

            case 23:
              return _context4.finish(20);

            case 24:
              return _context4.finish(17);

            case 25:
              return _context4.abrupt("return", finalMap);

            case 26:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[9, 13, 17, 25], [18,, 20, 24]]);
    }));
    return _getResourcesMap.apply(this, arguments);
  }

  return {
    getResource: getResource,
    selectResource: selectResource,
    getResourcesMap: getResourcesMap
  };
}